export default __webpack_public_path__ + "static/floor-plan-2BR-a80f052a7af73607e42da0dd59be0b2f.pdf";